import { Button } from 'antd';

import { amplitudeTrack } from 'app/utils/track/amplitude';

import type { ExtranetPaymentDisplayProps } from '../../utils';

type VCCActionButtonProps = {
  displayProps: ExtranetPaymentDisplayProps;
  setVCCModalOpened: (opened: boolean) => void;
};

export const VCCActionButton = ({
  displayProps,
  setVCCModalOpened,
}: VCCActionButtonProps) => {
  if (displayProps.VCCActive || !displayProps.issuingAllowed) {
    return <></>;
  }

  return (
    <Button
      onClick={() => {
        setVCCModalOpened(true);
        amplitudeTrack('Click Configure Virtual Cards');
      }}
      type="primary"
    >
      Configure Virtual Cards
    </Button>
  );
};
